import StudentRepository from '../repositories/StudentRepository';
import { verifyPassword } from '../utils/crypto';

const SESSION_KEY = 'safeguardpro_student_session_v1';

const readSession = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

const writeSession = (session) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

const clearSession = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(SESSION_KEY);
};

export default class StudentPortalAuthService {
  constructor() {
    this.repository = new StudentRepository();
  }

  getSession() {
    return readSession();
  }

  getStudentById(id) {
    return this.repository.getById(id);
  }

  async signIn(reference, dob, password) {
    const trimmed = (reference || '').trim().toLowerCase();
    const normalizedPassword = typeof password === 'string' ? password.trim() : '';
    if (!trimmed) {
      return { error: 'Enter your student reference.' };
    }
    const students = this.repository.getAll();
    const student = students.find(
      (entry) =>
        (entry.reference || entry.id || '').toLowerCase() === trimmed ||
        (entry.email || '').toLowerCase() === trimmed
    );
    if (!student) {
      return { error: 'No student found with that reference.' };
    }
    if (student.portalPasswordHash) {
      if (!normalizedPassword) {
        return { error: 'Enter your portal password to continue.' };
      }
      const ok = await verifyPassword(normalizedPassword, student.portalPasswordHash);
      if (!ok) {
        return { error: 'Incorrect password.' };
      }
    } else {
      if (student.dob && dob && student.dob !== dob) {
        return { error: 'Date of birth does not match our records.' };
      }
      if (student.dob && !dob) {
        return { error: 'Enter your date of birth to continue.' };
      }
    }
    const session = {
      id: student.id,
      name: student.name,
      reference: student.reference
    };
    writeSession(session);
    return { session, student };
  }

  signOut() {
    clearSession();
  }
}
